import { render, staticRenderFns } from "./DataSekolahDinas.vue?vue&type=template&id=534dbfcc"
import script from "./DataSekolahDinas.vue?vue&type=script&lang=js"
export * from "./DataSekolahDinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports